import classNames from 'classnames';
import React, { useRef } from 'react';
import _uniqueId from 'lodash/uniqueId';
import { Icon } from '@material-ui/core';
import IconButton from '../IconButton';

/**
 * 通知メッセージ
 */
export interface NoticeProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;

  /**
   * タイトルラベル
   */
  titleLabel?: string | React.ReactNode;

  /**
   * アイコン
   */
  icon?: string;

  /**
   * 種類
   */
  type?: 'default' | 'white' | 'info' | 'success' | 'warning' | 'error';

  /**
   * 100%長さ
   */
  isLong?: boolean;

  /**
   * インラインスタイル
   */
  isInline?: boolean;

  /**
   * 閉じるボタンをクリックしたときのイベント
   */
  onClickClose?: () => void;
}

class Notice extends React.Component<NoticeProps> {
  render() {
    const { children, className, titleLabel, icon, type = 'default', isLong, isInline, onClickClose, ...props } = this.props;

    const classes = classNames(
      'uc-notification',
      `uc-notification--${type}`,
      isLong && 'uc-notification--long',
      isInline && 'uc-notification--inline',
      className
    );

    return (
      <div className={classes} {...props}>
        <div className={classNames('uc-notification__message', onClickClose && 'uc-notification__message--has-close-button')}>
          {icon && <Icon className='uc-notification__header-icon u-text-middle u-icon-s'>{icon}</Icon>}
          <span className='u-text-middle' data-testid='notice--label'>
            {titleLabel}
          </span>
          {children}
          {onClickClose && (
            <IconButton data-testid='notice-close-button' className='uc-notification__close-button' icon='close' aria-label='close' onClick={() => onClickClose()} />
          )}
        </div>
      </div>
    );
  }
}

export default Notice;
